import { startViewPosition, ImageTurbine as ImageTurbine_v2, ImageTurbine_Old } from "./WTG/Icons/WTG"
import {
    MapContainer,
    TileLayer,
} from "react-leaflet";
import L from "leaflet";

import Legend, {Legend_Old} from './Legend'
import { useEffect, useState } from 'react';
import { fetchValues } from '../API/index.js';
import Loader from './Loader'
import { Grid } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux'
import {  unSelect } from "../features/WTG/TurbineSlice";
import { fetchUploadValues } from "../API";
import { useNavigate } from "react-router-dom";

const tileBlack = "https://tiles.stadiamaps.com/tiles/alidade_smooth_dark/{z}/{x}/{y}{r}.png"
const tileWhite = "https://tiles.stadiamaps.com/tiles/alidade_smooth/{z}/{x}/{y}{r}.png"
const tileBlue = "https://tiles.stadiamaps.com/tiles/outdoors/{z}/{x}/{y}{r}.png"

const usedTile = tileBlue;


const DefaultZoom = 13;
const DefaultMaxZoom = 13;



/**
 * 
 * @returns A map display with the turbine park in focus.
 */

const Map = ({version}) => {
    const [zoom, setZoom] = useState(13);
    const [myLegends, setMyLegends] = useState([]);
    const [legendHtml, setLegendHtml] = useState(L.control({ position: "bottomright" }))
    const [map, setMap] = useState(null);
    const [mapConfig, setMapConfig] = useState(null);
    const dispatch = useDispatch();
    const newPark = useSelector((state) => state.turbine.status);
    let navigate = useNavigate();
    /**
     * id: {…}, parkID: , turbines: Array(32)
     */
    useEffect(() => {
        dispatch(unSelect())
         async function fetchData() {
             let response = null;
             try {
                response = await fetchUploadValues();
                let TurbineData = response.data;
                setMapConfig(TurbineData)
             } catch (err) {
                console.error("Error response:");
                console.error(err.response.data);    // ***
                console.error(err.response.status);  // ***
                console.error(err.response.headers); // ***
                if(err.response.status ===404){
                    navigate("/HowToUploadExcel", { replace: true });
                }
             } finally{
                 if(response?.data?.length === 0 ||response === null ){
                     // Response indicate, that no Excel file is stored on the server.
                     navigate("/HowToUploadExcel", { replace: true });
                 } 
                 
             }
               

        };
        if(newPark)fetchData();
    }, [newPark, version]);

    useEffect(() => {
       if(map) map.on("zoomend", function (e) { setZoom(e.target.getZoom()) });
    },[map])
    

    return mapConfig ? (

        <MapContainer
         style={{height:"95vh"}}
        
            center={startViewPosition(mapConfig)}
            zoom={DefaultZoom}
            maxZoom={DefaultMaxZoom}
            scrollWheelZoom={true}
            attributionControl={false}
            whenCreated={setMap}>
            <TileLayer url='https://tileserver.memomaps.de/tilegen/{z}/{x}/{y}.png' />

{version ? 
<>
    <ImageTurbine_v2 mapConfig={mapConfig} map={map} zoom={zoom}  />
    <Legend map={map} mapConfig={mapConfig} setLegendHtml={setLegendHtml} legendHtml={legendHtml}/>
</>        
:
<>
    <ImageTurbine_Old mapConfig={mapConfig} map={map} setLegends={setMyLegends} zoom={zoom} />
    <Legend_Old map={map} mapConfig={mapConfig} setLegendHtml={setLegendHtml} legendHtml={legendHtml}/>

</>
}
        

        </MapContainer>
    )
        :
        <Grid container
        >
            <Loader color={"#f5f5f5"} componentHeight={"200px"} />
        </Grid>
};
export default Map;


